import { Typography } from '@mui/material';
import { styled } from '@mui/system';

export const SectionTitle = styled(Typography)(({ theme, marginBottom }) => ({
  marginBottom: marginBottom ? `${marginBottom}` : theme.spacing(4),
  fontWeight: 600,
}));
